import { useRef, useState } from "react";
import * as Icons from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";

export const ActionsMenu = ({ id, items, compact = false, label = "Actions", onOpenChange }) => {
  const [open, setOpen] = useState(false);
  const changeOpen = (value) => { setOpen(value); onOpenChange?.(value); };
  const trigger = useRef(null);
  const content = useRef(null);
  const visible = items.filter((item) => item && item.hidden !== true);
  const keyboard = (event) => {
    const buttons = [...content.current.querySelectorAll('[role="menuitem"]:not(:disabled)')];
    if (event.key === "Tab") { event.preventDefault(); changeOpen(false); return; }
    if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const index = buttons.indexOf(document.activeElement);
    const next = event.key === "Home" ? 0 : event.key === "End" ? buttons.length - 1
      : (index + (event.key === "ArrowDown" ? 1 : -1) + buttons.length) % buttons.length;
    buttons[next]?.focus();
  };
  if (!visible.length) return null;
  return <Popover open={open} onOpenChange={changeOpen} modal={false}>
    <PopoverTrigger asChild>
      <button ref={trigger} type="button" data-testid={`${id}-trigger`} aria-label={label} aria-haspopup="menu" title={label}
        className={`shrink-0 inline-flex items-center justify-center gap-2 rounded-md border border-border bg-card hover:bg-muted transition-colors font-semibold text-sm ${compact ? "p-2" : "px-4 py-2"}`}>
        {compact ? <Icons.MoreHorizontal size={18} /> : <>{label}<Icons.ChevronDown size={15} /></>}
      </button>
    </PopoverTrigger>
    <PopoverContent ref={content} role="menu" aria-label={label} onKeyDown={keyboard} align="end"
      onOpenAutoFocus={(event) => { event.preventDefault(); content.current?.querySelector('[role="menuitem"]:not(:disabled)')?.focus(); }}
      onCloseAutoFocus={(event) => { event.preventDefault(); if (!document.querySelector('[role="dialog"], [role="alertdialog"]')) trigger.current?.focus(); }}
      className="w-80 p-1 max-w-[calc(100vw_-_2rem)] max-h-[var(--radix-popover-content-available-height)] overflow-y-auto bg-card text-foreground border-border shadow-lg data-[state=closed]:animate-none" data-testid={`${id}-menu`}>
      {visible.map((item) => {
        const Icon = Icons[item.icon] || Icons.ChevronRight;
        return <button type="button" role="menuitem" tabIndex={-1} key={item.id} data-testid={item.id} disabled={item.disabled}
          onClick={() => { changeOpen(false); item.onSelect?.(); }} className={`w-full flex items-center text-left px-2 py-2 rounded-sm text-sm gap-2 cursor-pointer whitespace-normal outline-none hover:bg-muted focus:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${item.destructive ? "text-destructive" : ""}`}>
          <Icon size={15} className="shrink-0" /><span className="min-w-0 break-words">{item.label}</span>
        </button>;
      })}
    </PopoverContent>
  </Popover>;
};